/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ShowsSlider/theme';

export const ShowsSliderTheme = theme;
